import { render, staticRenderFns } from "./hina-textarea.vue?vue&type=template&id=2c3dadb6&scoped=true"
import script from "./hina-textarea.vue?vue&type=script&lang=ts"
export * from "./hina-textarea.vue?vue&type=script&lang=ts"
import style0 from "./hina-textarea.vue?vue&type=style&index=0&id=2c3dadb6&prod&lang=scss"
import style1 from "./hina-textarea.vue?vue&type=style&index=1&id=2c3dadb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3dadb6",
  null
  
)

export default component.exports